import { Box } from '@mantine/core';
import type { ReactNode } from 'react';

const GUTTER = 16;

/**
 * A block that spans the viewport instead of the centred page column: both edges move out to the
 * viewport's, less a gutter. The same trick the wide report map uses.
 */
export function FullBleed({ children }: { children: ReactNode }) {
  return (
    <Box data-full-bleed style={{ marginLeft: `calc(50% - 50vw + ${GUTTER}px)`, marginRight: `calc(50% - 50vw + ${GUTTER}px)` }}>
      {children}
    </Box>
  );
}
